import { ModalWindow } from "../UI/ModalWindow";
import { Input, TextArea } from '../UI/FormElements'

const ROUTE_URL = "/services";
const initialData = { name: "", description: "" };

function Service({ params, handleClose }) {

  let urlSubmit, urlGet;
  if (params.isNew) {
    urlSubmit = ROUTE_URL;
    urlGet = ""; //или ROUTE_URL + "/create" если при создании НАДО предварительное обращение к серверу
  }
  else {
    urlGet = ROUTE_URL + "/" + params.id;
    urlSubmit = urlGet;
  }
  return (
    <ModalWindow params={params} handleClose={handleClose} initialData={initialData} urlGet={urlGet} urlSubmit={urlSubmit} >
      <ServiceFields />
    </ModalWindow>
  );
}

const ServiceFields = ({ dopParams, ...elementProps }) => {
  return (
    <div className="row form-gutter">
      <div className="col-12">
        <Input label="Наименование" name="name" {...elementProps} required autoFocus />
      </div>
      <div className="col-12">
        <TextArea label="Описание" name="description" {...elementProps} rows="10" required />
      </div>
    </div>
  )
}
export default Service;
